<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>我的提现</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <div class="dropdownTitle">
                <p class="currTitle">我的提现</p>
               
            </div>
            <div class="bookingItems">
                <div>
                    <p>-3</p>
                    <span>2023-06-17 22:19:43</span>
                </div>
                <div>
                    <p><span>余额：</span> 7</p>
                    <span class="successToCash">提现成功</span>
                </div>
            </div>
            <div class="bookingItems">
                <div>
                    <p>-2</p>
                    <span>2023-06-16 22:19:43</span>
                </div>
                <div>
                    <p><span>余额：</span> 7</p>
                    <span class="errorToCash">提现失败</span>
                </div>
            </div>
            <div class="bookingItems">
                <div>
                    <p>-5</p>
                    <span>2023-06-15 22:19:43</span>
                </div>
                <div>
                    <p><span>余额：</span> 117</p>
                    <span class="successToCash">提现成功</span>
                </div>
            </div>
            
            <!-- <div v-show="vsData == ''" class="teamsNull">
                <p>亲，未找到记录~</p>
            </div>
            -->
            
            <div style="text-align: right;">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="10"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            vsData: [],
            total: 0,
            hideOnSinglePage: true,
            hData:[{'isused':'0','name':'未使用','isexpired':'0'},{'isused':'1','name':'已使用','isexpired':'0'},{'isused':'0','name':'已过期','isexpired':'1'}],
            widthNew: false
        
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listByUser(data){
            this.$store.dispatch('personal/myApplyToCash',data)
            .then(res => {
                if(res.ok){
                    this.total = res.data.total

                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                    this.vsData = res.data.items
                   
                }
            })
        },
       
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listSign = {
                vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
                vsfrom: 'app',
                mallToken: '',
                pageNo: val,
                pageSize: '10'
    
            }
            this.listByUser(listSign)
        },
    
    },
    mounted(){
        
       
    },
    created(){
        localStorage.setItem('active','2-8')
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let listFav = {
            vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
            vsfrom: 'app',
            mallToken: '',
            pageNo: '1',
            pageSize: '10'
        }
        // this.listByUser(listFav)
    }
}
</script>


<style scoped lang="scss">
@import url(../../css/personal.css);


.dropdownTitle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #f2f2f2;
    padding:  0 10px 10px 0;
    .currTitle{
        border: none;
    }
}
.bookingItems{
    margin: 10px 0 20px 0;
    padding: 10px 10px 25px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #f2f2f2;
    div {
        text-align: right;
        p{
            font-size: 25px;
            margin-bottom: 10px;
            text-align: left;
        }
        span{
            font-size: 16px;
            color: #888888;
           
        }
        .errorToCash{
            color: tomato;
        }
        .successToCash{
            // color: #10aeff;
        }
    }

}
</style>